/**
 * Provides singleton to import for the persistent record use case.
 */
import RecordSDKInitializer from '../recordSDKInitializer';

// Persistent record redirects to Loom share page and tests FTUX.
const config = {
  disablePreviewModal: true,
  enableOnboardingTutorial: true,
};
let getSdkInstance;

function getSDKInstance(): RecordSDKInitializer {
  if (!getSdkInstance) {
    getSdkInstance = new RecordSDKInitializer(config);
  }

  return getSdkInstance;
}

export default getSDKInstance;
